const REACT_APP_API = process.env.REACT_APP_API
const REACT_APP_API_ABM = process.env.REACT_APP_API_ABM
const REACT_APP_API_ABM_FW = process.env.REACT_APP_API_ABM_FW
const REACT_APP_API_SF = process.env.REACT_APP_API_SF
const REACT_APP_CURRENT_YEAR = process.env.REACT_APP_CURRENT_YEAR
const REACT_APP_PERITADOR_API = process.env.REACT_APP_PERITADOR_API
// const REACT_APP_PRICING_API = process.env.REACT_APP_PRICING_API
const REACT_APP_COTIZADOR_API = process.env.REACT_APP_COTIZADOR_API
const REACT_APP_IMG = process.env.REACT_APP_IMG || ''
const REACT_APP_WHATSAPP_FILES = process.env.REACT_APP_WHATSAPP_FILES
const REACT_APP_PERITADOR_FE = process.env.REACT_APP_PERITADOR_FE
const REACT_APP_RV = process.env.REACT_APP_RV
const REACT_APP_PRECIOJUSTO_API = process.env.REACT_APP_PRECIOJUSTO_API
const REACT_APP_GESTORIA_API = process.env.REACT_APP_GESTORIA_API
let CDN_COMPLETE_URL_IMG = REACT_APP_IMG
if(CDN_COMPLETE_URL_IMG.startsWith('/')) {
  CDN_COMPLETE_URL_IMG = window.location.origin + CDN_COMPLETE_URL_IMG
}
const REACT_APP_SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH
const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL
const REACT_APP_GEOAPIFY_KEY = process.env.REACT_APP_GEOAPIFY_KEY

const REACT_APP_SESSION_EXPIRES_AT_IN_MINUTES = Number(process.env.REACT_APP_SESSION_EXPIRES_AT_IN_MINUTES || 0) || 4320 // 72hs

export {
    REACT_APP_COTIZADOR_API,
    REACT_APP_API,
    REACT_APP_API_ABM,
    REACT_APP_API_ABM_FW,
    REACT_APP_PERITADOR_API,
    REACT_APP_API_SF,
    // REACT_APP_PRICING_API,
    REACT_APP_IMG,
    REACT_APP_WHATSAPP_FILES,
    REACT_APP_CURRENT_YEAR,
    REACT_APP_PERITADOR_FE,
    REACT_APP_RV,
    REACT_APP_PRECIOJUSTO_API,
    REACT_APP_GESTORIA_API,
    CDN_COMPLETE_URL_IMG,
    REACT_APP_SOCKET_PATH,
    REACT_APP_BASE_URL,
    REACT_APP_SESSION_EXPIRES_AT_IN_MINUTES,
    REACT_APP_GEOAPIFY_KEY
}
